import { Component, Inject, OnInit } from '@angular/core';
import { inject } from '@angular/core/testing';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ChatService } from '../../../../../services/chat.service';
import { Subscription } from 'rxjs';
import { HubConnection } from '@microsoft/signalr';
import { LoginService } from '../../../../../services/login.service';
import { PaginaErroComponent } from '../../../componetes-comum/pagina-erro/pagina-erro.component';

@Component({
  selector: 'ngx-visualiza-conversa',
  templateUrl: './visualiza-conversa.component.html',
  styleUrls: ['./visualiza-conversa.component.scss']
})
export class VisualizaConversaComponent implements OnInit {

  chat: any
  solicitante
  chatInterface
  subscribeNewMessage: Subscription
  connection: HubConnection
  usuarioLogado
  arquivosChat
  contato = ''
  constructor(@Inject(MAT_DIALOG_DATA) data,
    private chatService: ChatService,
    private loginService: LoginService,
    private dialog: MatDialog) {
    this.solicitante = data.solicitante
    this.chatInterface = data.chatInterface
    this.connection = data.connection
    this.chatService.requisitaChat(this.chatInterface.PhoneNumberIdProd, this.chatInterface.Telefone, this.chatInterface.IdEquipeChat)
    .toPromise()
    .then(response => {
      console.log(response)
      this.chat = this.chatService.retornaChat(response)
      console.log(this.chat)
    })
  }

  ngOnInit(): void {

    this.subscribeNewMessage = this.chatService.novaMensagem$.subscribe(response => {
      
      console.log(response)
        if (response.chatId == this.connection.baseUrl) {
          this.chat.push(
            {
              text: response.message.type == 'text' ? response.message.text : null,
              date: response.message.Date,
              reply: response.message.reply,
              user: {
                name: response.message.userName,
                avatar: 'https://cdn-icons-png.flaticon.com/512/6596/6596121.png'
              },
              type: response.message.type != 'text' ? 'file' : 'text',
              files: this.retornaFilesFormat(response.message),
              customMessage: response.message.type == 'audio/ogg' ? true : false
            }
          )

          if (response.message.type == 'audio/ogg') {
            let dots = '';
            const maxDots = 3;
            const intervalDuration = 500;
            const uniqueId = new Date().getTime()
            // Adiciona a mensagem de "Aguardando transcrição do audio..."
            const waitingMessage = {
              text: 'Aguardando transcrição do audio' + dots,
              date: '',
              reply: false,
              type: 'text',
              user: {
                name: response.message.userName,
                avatar: 'https://cdn-icons-png.flaticon.com/512/6596/6596121.png'
              },
              id: uniqueId
            };

            this.chat.push(waitingMessage);

            // Atualiza a mensagem com pontos piscando
            const interval = setInterval(() => {
              dots += '.';
              if (dots.length > maxDots) {
                dots = '';
              }
              // Atualiza o texto da mensagem de espera
              waitingMessage.text = 'Aguardando transcrição do audio' + dots;

              // Atualiza a mensagem no chat
              this.chat = [...this.chat];

            }, intervalDuration);
            this.getTranscricaoAudio(response.message.nomeArquivo, this.chatInterface.Telefone, this.chatInterface.PhoneNumberIdProd, `${this.chat.length - 1}`, response.message.Date, interval)

          }
        }
      })

  }

  getTranscricaoAudio(nomeArquivo: string, telefone: string, phoneNumberId: string, posicaoChat: string, dataHoraAudio: string, interval) {
    this.chatService.requisitaTranscricaodeAudio(nomeArquivo, telefone, phoneNumberId, posicaoChat, dataHoraAudio)
      .toPromise()
      .then((response: string) => {
        clearInterval(interval)
        this.chat[posicaoChat].text = response
      })
      .catch(err => {
        clearInterval(interval)
        this.chat[posicaoChat].text = err.error.text
      })
  }

  retornaFilesFormat(message) {
    let files = []
    if (message.type != 'text') {
      switch (message.type) {
        case "image/jpeg":
          files.push({
            url: message.text,
            // type: message.type,
            icon: 'image'
          })
          break;

        case 'image/png':
          files.push({
            url: message.text,
            // type: message.type,
            icon: 'image'
          })
          break;

        case 'image/gif':
          files.push({
            url: message.text,
            // type: message.type,
            icon: 'image'
          })
          break;

        case 'text/csv':
          files.push({
            url: message.text,
            // type: message.type,
            icon: 'excel'
          })
          break;
        case 'application/pdf':
          files.push({
            url: message.text,
            // type: message.type,
            icon: 'pdf'
          })
          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          files.push({
            url: message.text,
            icon: 'excel'
          })
          break;
        case 'application/msword':
          files.push({
            url: message.text,
            // type: message.type,
            icon: 'word'
          })
          break;

        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          files.push({
            url: message.text,
            // type: message.type,
            icon: 'word'
          })
          break;

        case 'audio/ogg':
          files.push({
            url: message.text,
            // type: message.type,
            icon: 'audio'
          })
          break;

        case 'video/mp4':
          files.push({
            url: message.text,
            icon: 'video'
          })
          break;
          
        default:
          files.push({
            url: message.text,
            // type: message.type,
            icon: 'padrao'
          })
          break;
      }
      return files
    }
    else {
      return null;
    }
  }

   sendMessage(event) {
    if (event.files.length > 0) {
      this.processaArquivos(event.files)
        .then(response => {
          this.connection.invoke('NewFileFromChat', this.usuarioLogado.Nome, event.message, this.chatInterface.Telefone, `${parseInt(this.chatInterface.Telefone) + parseInt(this.chatInterface.PhoneNumberIdProd)}`, this.chatInterface.PhoneNumberIdProd, this.arquivosChat)
            .then((res: any) => {
              if (res.statusCode == 200) {
                this.chatService.statusEnviandoArquivo(false);
                event.files.forEach((file: File) => {
                  this.chat.messages.push({
                    text: event.message,
                    date: new Date(),
                    reply: true,
                    user: {
                      name: this.usuarioLogado.Nome,
                    },
                    type: 'file',
                    files: this.retornaFilesFormat(file)
                  });
                })

                this.arquivosChat = [];
              }
              if (res.statusCode == 400) {
                this.abrirPaginaErro(res.value.message, 'interno');
                this.chatService.statusEnviandoArquivo(false);
              }
              if (res.statusCode == 409) {
                this.abrirPaginaErro(res.value.message, 'interno')
                this.chatService.statusEnviandoArquivo(false);
              }
            })
            .catch(err => {
              console.log(err)
            })
        }).catch(err => {
          this.abrirPaginaErro(err, 'erro')
        })
    }

    else {
      this.connection.send('NewMessageFromChat', this.usuarioLogado.Nome, event.message, this.chatInterface.Telefone, `${parseInt(this.chatInterface.Telefone) + parseInt(this.chatInterface.PhoneNumberIdProd)}`, this.chatInterface.PhoneNumberIdProd, null)
        .then(res => {

          this.chat.messages.push({
            text: event.message,
            date: new Date(),
            reply: true,
            user: {
              name: this.usuarioLogado.Nome,
            },
          });
        })
        .catch(err => {
          console.log(err)
        })
    }
  }

   processaArquivos(files: File[]): Promise<string | any> {
    const reader = new FileReader();
    let soma = 0
    files.forEach((file: File) => {
      soma = soma + file.size
    });

    if (soma < 50000000) {
      let fileIndex = 0
      const readFile = (): Promise<void> => {
        return new Promise((resolve, reject) => {
          if (fileIndex < files.length) {
            const file = files[fileIndex];
            reader.onload = (event) => {
              const result = event.target.result as string;
              this.arquivosChat.push({
                File: result,
                Type: files[fileIndex].type,
                Name: files[fileIndex].name
              });
              fileIndex++;
              readFile()
                .then(resolve)
                .catch(reject);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
          } else {
            resolve();
          }
        });
      };
      return readFile().then(() => {
        this.arquivosChat
      });
    }
    else {
      this.chatService.statusEnviandoArquivo(false);
      this.abrirPaginaErro('O tamanho máximo dos arquivos somados são 50MB!', 'interno')
    }
  }

  abrirPaginaErro(mensagem, tipo) {
      const dialogConfig = new MatDialogConfig();
  
      dialogConfig.data = {
        mensagem: mensagem,
        tipo: tipo
      }
      this.dialog.open(PaginaErroComponent, dialogConfig);
    }

    
}
